import logo2004 from "../../assets/img/historicEvents/LogoTaboo/2004.png";
import logo2005 from "../../assets/img/historicEvents/LogoTaboo/2005.png";

export const tabooTuesdayDetail = {
  "taboo-tuesday": {
    id: "taboo-tuesday",
    title: "Taboo Tuesday",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "taboo-tuesday",
        items: [
          {
            id: "taboo-tuesday-2004",
            title: "Taboo Tuesday",
            description: "You Control – The fate of Raw superstars... 2004",
            imgUrl: logo2004,
          },
          {
            id: "taboo-tuesday-2005",
            title: "Taboo Tuesday",
            description: "Log on. Take over. 2005",
            imgUrl: logo2005,
          },
        ],
      },
    ],
  },
};
